<template>
<h1>404</h1>
</template>

<script>
// @ is an alias to /src

export default {
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
